import React from 'react';
import { PictoProps } from './index';

export const SwitchRight = (props: PictoProps) => (
  <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="0.999996"
      y="24.5"
      width="24"
      height="24"
      rx="6.5"
      transform="rotate(-90 0.999996 24.5)"
      stroke="#000000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.276 12.0225L10.8253 7.1976C10.508 6.93413 10.0227 6.93413 9.724 7.1976C9.42533 7.46108 9.42533 7.90569 9.724 8.16916L14.6333 12.5L9.724 16.8308C9.42533 17.1108 9.42533 17.5389 9.724 17.8024C10.0227 18.0659 10.508 18.0659 10.8253 17.8024L16.276 12.994C16.5747 12.7141 16.5747 12.2859 16.276 12.0225Z"
      fill="#000000"
    />
  </svg>
);
